import React, { useCallback, useContext } from 'react'

import LineHeartSlashIcon from 'LuxKit/Icons/line/LineHeartSlashIcon'
import LinePenIcon from 'LuxKit/Icons/line/LinePenIcon'
import LineSettingIcon from 'LuxKit/Icons/line/LineSettingIcon'
import LineTrashAltIcon from 'LuxKit/Icons/line/LineTrashAltIcon'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCurrentUserId } from 'selectors/accountSelectors'
import DeleteTripItem from 'tripPlanner/components/TripModal/TripItems/DeleteTripItem'
import EditTripItem from 'tripPlanner/components/TripModal/TripItems/Edit'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { ItemMetadata } from 'tripPlanner/models'
import { TripItem } from 'tripPlanner/types/tripItem'
import { getOrderId, isCustomItem, isLeItem } from 'tripPlanner/utils'
import LineEditAltIcon from 'LuxKit/Icons/line/LineEditAltIcon'
import { TripDocumentsContext } from 'tripPlanner/contexts/TripDocumentsContext'
import LinePaperclipIcon from 'LuxKit/Icons/line/LinePaperclipIcon'
import TripContext from 'tripPlanner/contexts/TripContext'

interface Props {
  item: TripItem
  onRequestAddNote?: () => void
}

export default function ItemMenuOptions(props: Props) {
  const { item, onRequestAddNote } = props
  const openModal = useOpenModal()
  const tripContext = useContext(TripContext)

  const canShowEdit = isCustomItem(item) && ItemMetadata[item.type].editable
  const isLEItem = isLeItem(item)
  const canEdit = tripContext?.permissions.canEdit ?? false

  const orderId = getOrderId(item)
  const userId = useAppSelector(getCurrentUserId)

  const documentsContext = useContext(TripDocumentsContext)

  const handleDeleteItem = useCallback(() => {
    openModal(DeleteTripItem, { item }, { height: 'auto' })
  }, [openModal, item])

  return (
    <>
      {canShowEdit && (
        <ClickableListItem
          startIcon={<LinePenIcon size="S" />}
          onClick={() => openModal(EditTripItem, { item })}
          title="Edit"
        />
      )}
      {orderId && item.createdBy === userId && (
        <ClickableListItem
          startIcon={<LineSettingIcon size="S" />}
          title="Manage booking"
          to={`/account/my-escapes/order/${orderId}`}
          target="_blank"
        />
      )}
      {isLEItem && (
        <ClickableListItem
          startIcon={<LineHeartSlashIcon size="S" />}
          onClick={() =>
            openModal(DeleteTripItem, { item }, { height: 'auto' })}
          title="Unsave"
        />
      )}
      {!!onRequestAddNote && !item.notes && (
        <ClickableListItem
          startIcon={<LineEditAltIcon size="S" />}
          onClick={onRequestAddNote}
          title="Add note"
        />
      )}
      {!!documentsContext && (
        <ClickableListItem
          startIcon={<LinePaperclipIcon size="S" />}
          onClick={() => documentsContext.onRequestAddDocument(item.id)}
          title="Attach document"
        />
      )}
      {!isLEItem && canEdit && (
        <ClickableListItem
          startIcon={<LineTrashAltIcon size="S" />}
          onClick={handleDeleteItem}
          title="Delete from trip"
        />
      )}
    </>
  )
}
